<template>
    <div id="campaigns-editor">
        <div class="col-md-12 text-center" v-if="loading">
            <i class="fa fa-spinner fa-spin inner-loading"></i>
        </div>

        <div class="row" dusk="ready" v-else>
            <div class="col-sm-10 col-sm-offset-1">
                <div class="row page-title">
                    <div class="col-md-12">
                        <h1>Edit {{ campaign.product_category.name | capitalize }} Campaign</h1>
                        <p></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <campaign-editor
                            v-model="campaign"
                            :validation="validation"
                            :dimensions="dimensions"
                            :base-url="baseUrl"
                            :user-roles="userRoles"
                            :show-errors="showErrors"
                            v-bind:editing="true">
                        </campaign-editor>

                        <div class="row buttons" v-cloak>
                            <div class="col-md-5">
                                <button id="save_campaign" v-on:click="saveAndReturn()" type="button" class="btn btn-block --gray --gray-border">Save Campaign</button>
                            </div>
                            <div class="col-md-5 col-md-offset-2">
                                <button id="cancel_campaign_changes" v-on:click="cancelAndReturn()" class="btn btn-block --gray --gray-border">Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import campaignCommon from 'js/campaigns/common'
    import Swal from "sweetalert2";

    export default {
        mixins: [campaignCommon],
        name: 'CampaignEdit',
        props: ['campaignData', 'userRoles'],
        data: function () {
            return {
                campaign: this.campaignData,
                dateStart: {
                    time: ''
                },
                dateEnd: {
                    time: ''
                },
                campaignNames: [],
                dimensions: {
                    ad_products: [],
                    budget_intervals: []
                },
                baseUrl: window.Portal.baseUrl,
                showErrors: false,
                loading: true
            }
        },

        computed: {
            validation: function() {
                return {
                    name: !!this.campaign.name.trim(),
                    nameUnique: _.indexOf(this.campaignNames, this.campaign.name.trim().toLowerCase()) == -1,
                    product_category: typeof this.campaign.product_category['id'] != 'undefined',
                    ad_product: typeof this.campaign.ad_product['id'] != 'undefined',
                    budget_amount:  !!this.isValidBudgetAmount,
                    budget_interval: !!(this.campaign.budgets[0]['budget_interval'] && this.campaign.budgets[0]['budget_interval'] != 'none'),
                    budget_end_not_after_start: this.campaign.end_date == '' || moment(this.campaign.start_date).isBefore(this.campaign.end_date, 'day')
                };
            },

            isValidBudgetAmount: function () {
                return this.campaign.budgets.reduce(function (total, budget) { return total + budget.budget; }, 0) > 0 ||
                    Number(this.campaign.budgets[0]['budget_interval']) === 9;
            },

            isValid: function () {
                var validation = this.validation;
                return Object.keys(validation).every(function (key) {
                    return validation[key];
                })
            }
        },

        watch: {
            'dateStart.time': function() {
                this.campaign.start_date = this.dateStart.time;
            },

            'dateEnd.time': function() {
                this.campaign.end_date = this.dateEnd.time;
            }
        },

        methods: {
            loadCampaign: function() {
                var self = this;

                this.campaign.start_date = this.campaign.start_date ? moment(this.campaign.start_date).format('MM/DD/YYYY') : '';
                this.campaign.end_date = this.campaign.end_date ? moment(this.campaign.end_date).format('MM/DD/YYYY') : '';

                return this.loadNames(function(currentCampaignNames) {
                    var position = _.indexOf(currentCampaignNames, self.campaign.name.trim().toLowerCase());
                    if (position !== -1) {
                        currentCampaignNames.splice(position, 1);
                    }
                });
            },

            loadNames: function(callback) {
                return this.$http.get(route('api.advertiser.campaign-names', { vertical: this.campaign.product_category.name.toLowerCase() })).then(function(response) {
                    if (response.body.success) {
                        this.campaignNames = response.body.campaignNames;
                        if (typeof callback === 'function') callback(this.campaignNames);
                    }
                });
            },

            getDimensions() {
                return this.$http.get(route('campaigns.dimensions.index')).then(function (response) {
                    if (response.data.success) {
                        this.dimensions = response.data.dimensions;
                    }
                });
            },

            save: function(goToUrl) {
                var self = this;

                if (!this.isValid) {
                    this.showErrors = true;
                    return false;
                }

                $.loading.show();

                this.$http.patch(route('campaigns.update', this.campaign.id), this.campaign).then(function(response) {
                        $.loading.hide();
                        if (response.body.success) {
                            this.showSuccessMessage('Campaign saved successfully!', this.redirect.bind(null, goToUrl));
                        } else {
                            this.notifyRollbar('Edit Campaign Failure: components/campaigns/edit.vue@save: line 150', response);
                            this.showErrorMsg('Error encountered while saving the campaign.');
                        }
                    },
                    function (errorResponse) {
                        $.loading.hide();
                        this.notifyRollbar('Edit Campaign Failure: components/campaigns/edit.vue@save: line 150', errorResponse);
                        this.manageErrors(errorResponse);
                    });
            },

            saveAndReturn: function () {
                return this.save(route('campaigns.show', this.campaign.id));
            },

            cancelAndReturn: function () {
                return this.redirect(route('campaigns.show', this.campaign.id));
            },

            redirect: function(url) {
                window.location = url;
            },

            showErrorMsg: function(message) {
                $.loading.hide();
                this.showErrorMessage(message);
            },

            setValidation: function(field, status) {
                this.validationFields[field] = status;
            }
        },

        mounted: function() {
            Promise.all([
                this.loadCampaign(),
                this.getDimensions()
            ]).then(() => {
                this.loading = false;
            }).catch((error) => {
                new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error');
            });
        }
    }
</script>

<style>
    .row.buttons {
        padding-bottom: 20px;
    }
</style>
